import { Bot, Brain, BookMarked, Lightbulb, Search, StickyNote } from 'lucide-react';
import LectureAiChip from './LectureAiChip';

const iconsById = {
  search_memory: Search,
  review_weak_areas: Brain,
  log_confusion_point: Lightbulb,
  create_revisit_task: BookMarked,
  attach_library_context: Bot,
  save_note_summary: StickyNote,
};

export default function AgentToolRail({ tools = [], onToolClick, title = 'Allowlisted tools' }) {
  if (!tools.length) return null;

  return (
    <div className="space-y-2">
      <p className="text-xs font-semibold uppercase tracking-[0.18em] text-muted-foreground">{title}</p>
      <div className="flex flex-wrap gap-2">
        {tools.map((tool) => (
          <LectureAiChip
            key={tool.id}
            icon={iconsById[tool.id] || Bot}
            label={tool.label}
            meta={tool.category}
            tone="tool"
            onClick={onToolClick ? () => onToolClick(tool) : undefined}
          />
        ))}
      </div>
    </div>
  );
}
